import { refreshCache } from 'lib/cache-utils'
import { errorMessage, successMessage } from 'lib/flash-message'
import { MenuItem } from 'react-bootstrap'
import { DropdownButton } from 'components/DropdownButton/DropdownButton'

import css from './admin-tool.scss'

const AdminTool = () => {
  const handleClearCache = () => {
    refreshCache([{ name: window.location.href }])
      .then((resp) => {
        successMessage(
          'Success! Cache for this page will be cleared in a few minutes.'
        )
      })
      .catch((error) => {
        errorMessage('Uh oh...there was an error try to clear the cache!')
      })
  }

  return (
    <div className={css.adminButton}>
      <DropdownButton pullRight bsSize="small" bsStyle="default">
        <MenuItem onClick={handleClearCache}>Clear Cache</MenuItem>
      </DropdownButton>
    </div>
  )
}

export default AdminTool
